(function () {
  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  function initBar(bar) {
    var rotate = bar.getAttribute("data-announcement-rotate") === "true";
    var intervalSec = parseInt(bar.getAttribute("data-announcement-interval") || "4", 10);
    var slides = Array.prototype.slice.call(bar.querySelectorAll("[data-announcement-slide]"));

    if (!slides.length) return;

    // Ensure exactly one is active to start
    var i = slides.findIndex(function (s) { return s.classList.contains("is-active"); });
    if (i < 0) i = 0;

    slides.forEach(function (s, idx) {
      s.classList.toggle("is-active", idx === i);
    });

    // If rotation off, only one slide, or reduced motion: keep first active
    if (!rotate || slides.length < 2 || prefersReducedMotion()) {
      slides.forEach(function (s, idx) {
        s.classList.toggle("is-active", idx === 0);
      });
      return;
    }

    window.setInterval(function () {
      slides[i].classList.remove("is-active");
      i = (i + 1) % slides.length;
      slides[i].classList.add("is-active");
    }, Math.max(2, intervalSec) * 1000);
  }

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".pxs-announcement-bar[data-announcement-rotate]").forEach(initBar);
  });
})();